import {
  type PayOutAccountAeropay,
  type PayOutAccountBank,
  type PayOutAccountPayPal,
  type PayOutAccountsQuery,
  PayOutAccountType,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

export type PayoutStoredAccounts = PayOutAccountsQuery['payOutAccounts']['accounts']

export const getProps = (
  account: PayoutStoredAccounts[number],
): PayOutAccountAeropay | PayOutAccountBank | PayOutAccountPayPal => {
  switch (account.type) {
    case PayOutAccountType.Aeropay:
      return account as PayOutAccountAeropay
    case PayOutAccountType.Bank:
      return account as PayOutAccountBank
    case PayOutAccountType.PayPal:
      return account as PayOutAccountPayPal
    default:
      throw new Error(`Unsupported account type: ${account.type}`)
  }
}
